import { render, staticRenderFns } from "./TheTheming.vue?vue&type=template&id=d9deddc4&"
import script from "./TheTheming.vue?vue&type=script&lang=js&"
export * from "./TheTheming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports